<template>
    <el-dialog
        class="dialog"
        top="8vh"
        width="40%"
        :title="title"
        :visible.sync="visible"
        @close="onDialogClose"
        :before-close="done => !isSubmiting && done()">
        <el-form
            class="form"
            ref="form"
            :model="formData"
            :rules="formRules"
            label-position="left"
            label-width="110px">
            <el-form-item
                label="所属权限组"
                prop="_topId">
                <el-select
                    class="w100"
                    v-model="formData._topId"
                    @change="getLevel1Menus">
                    <el-option
                        label="请选择"
                        :value="undefined" />
                    <el-option
                        label="顶级权限"
                        :value="0" />
                    <el-option
                        v-for="item in select"
                        :key="item.id"
                        :label="item.display_name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item
                label="一级节点"
                prop="_level1Id">
                <el-select
                    class="w100"
                    v-model="formData._level1Id"
                    @change="getLevel2Menus">
                    <el-option
                        label="请选择"
                        :value="undefined" />
                    <el-option
                        v-for="item in level1Menus"
                        :key="item.id"
                        :label="item.display_name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item
                label="二级节点"
                prop="_level2Id">
                <el-select
                    class="w100"
                    v-model="formData._level2Id">
                    <el-option
                        label="请选择"
                        :value="undefined" />
                    <el-option
                        v-for="item in level2Menus"
                        :key="item.id"
                        :label="item.display_name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item
                label="显示名称"
                prop="display_name">
                <el-input v-model="formData.display_name" />
            </el-form-item>
            <el-form-item
                label="路由"
                prop="name">
                <el-input v-model="formData.name" />
            </el-form-item>
            <el-form-item
                label="图标"
                prop="icon">
                <el-input v-model="formData.icon" />
            </el-form-item>
            <el-form-item
                label="是否菜单"
                prop="is_menu">
                <el-radio
                    v-model="formData.is_menu"
                    :label="true">
                    是
                </el-radio>
                <el-radio
                    v-model="formData.is_menu"
                    :label="false">
                    否
                </el-radio>
            </el-form-item>
            <el-form-item
                label="菜单等级"
                prop="level">
                <el-select
                    class="w100"
                    v-model="formData.level">
                    <el-option
                        v-for="item in menuLevel"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item
                label="排序"
                prop="sort">
                <el-input-number
                    class="input-number"
                    v-model="formData.sort"
                    controls-position="right"
                    :min="0"
                    :precision="0" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button
                type="info"
                round
                :disabled="isSubmiting"
                @click="visible = false">
                取 消
            </el-button>
            <el-button
                type="primary"
                round
                :loading="isSubmiting"
                @click="submit">
                确 定
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getPowerNodeSelect, creatPower, editPower } from '../../../../api';
import { deepCopy } from '../../../../utils/util';

export default {
    name: 'OperationPower',
    data () {
        const checkName = (rule, value, callback) => {
            if (value.trim() === '') {
                return callback(new Error('请输入路由'));
            }
            if (this._name) {
                if (this._name === value.trim()) {
                    return callback(new Error('路由已存在'));
                } else {
                    return callback();
                }
            } else {
                return callback();
            }
        };

        return {
            visible: false,
            currentId: null,
            isSubmiting: false,
            formData: {
                _topId: undefined,
                _level1Id: undefined,
                _level2Id: undefined,
                parent_id: 0,
                level: 1,
                icon: '',
                is_menu: false,
                sort: 0,
                name: '',
                display_name: ''
            },
            formRules: {
                _topId: [
                    { required: true, message: '请选择所属权限组', trigger: 'change' }
                ],
                display_name: [
                    { required: true, message: '请输入显示名称', trigger: 'blur' }
                ],
                name: [
                    { required: true, validator: checkName, trigger: 'blur' }
                ]
            },
            menuLevel: [],
            select: [],
            level1Menus: [],
            level2Menus: []
        };
    },
    computed: {
        title () {
            return this.currentId ? '编辑权限' : '添加权限';
        }
    },
    created () {
        this._name = null; // 验证重复路由
    },
    methods: {
        async open ({ row }, isCreate) {
            try {
                this.visible = true;
                const _getData = this.getData();
                const parentIds = [];
                const getParent = node => {
                    if (node.parent) {
                        getParent(node.parent);
                    }
                    parentIds.push(node.parent_id);
                };
                getParent(row);
                await _getData;
                let _topId = undefined;
                let _level1Id = undefined;
                let _level2Id = undefined;
                if (parentIds[0] !== undefined) {
                    _topId = parentIds[0];
                    this.getLevel1Menus(parentIds[0]);
                    if (parentIds[1]) {
                        _level1Id = parentIds[1];
                        this.getLevel2Menus(parentIds[1]);
                        _level2Id = parentIds[2];
                    }
                }
                let { id, is_menu, level, name, display_name, sort, icon } = row;
                if (isCreate) {
                    id = null;
                    _level2Id = row.id;
                    this.formData = {
                        _topId,
                        _level1Id,
                        _level2Id,
                        level: level + 1 || 1,
                        icon: '',
                        is_menu: false,
                        sort: 0,
                        name: '',
                        display_name: ''
                    };
                } else {
                    this.formData = {
                        _topId,
                        _level1Id,
                        _level2Id,
                        level: level || 1,
                        icon: icon || '',
                        is_menu: is_menu || false,
                        sort: sort || 0,
                        name: name || '',
                        display_name: display_name || ''
                    };
                }
                this.currentId = id;
            } catch (err) {
                console.error(err);
            }
        },
        async getData () {
            try {
                const res = await getPowerNodeSelect();
                if (res) {
                    const { menuLevel, select } = res;
                    if (menuLevel) this.menuLevel = menuLevel;
                    if (select) this.select = select;
                }
            } catch (err) {
                console.error(err);
            }
        },
        onDialogClose () {
            this.$refs.form.resetFields();
        },
        submit () {
            if (this.isSubmiting) return;
            this.$refs.form.validate(async valid => {
                try {
                    if (valid) {
                        const { currentId } = this;
                        const apiFn = (data) => {
                            if (currentId) {
                                return editPower(currentId, data);
                            } else {
                                return creatPower(data);
                            }
                        };
                        this.isSubmiting = true;
                        const { formData } = this;
                        const { _topId, _level1Id, _level2Id } = formData;
                        if (_topId) formData.parent_id = _topId;
                        if (_level1Id) formData.parent_id = _level1Id;
                        if (_level2Id) formData.parent_id = _level2Id;
                        const params = deepCopy(formData);
                        await apiFn(params);
                        this.$emit('done');
                        this.$message.success(`${this.title}成功！`);
                        this.visible = false;
                        this.isSubmiting = false;
                        this._name = null;
                    }
                } catch (err) {
                    this.isSubmiting = false;
                    if (err && err.data && err.data.code === 422) {
                        this._name = this.formData.name;
                        this.$refs.form.validateField(['name']);
                    }
                    console.error(err);
                }
            });
        },
        getLevel1Menus (id) {
            const { formData, select } = this;
            formData._level1Id = undefined;
            formData._level2Id = undefined;
            const menus = select.find(c => c.id === id);
            let data = [];
            if (menus && menus.child) {
                data = menus.child;
            }
            this.level1Menus = data;
        },
        getLevel2Menus (id) {
            const { formData, level1Menus } = this;
            formData._level2Id = undefined;
            const menus = level1Menus.find(c => c.id === id);
            let data = [];
            if (menus && menus.child) {
                data = menus.child;
            }
            this.level2Menus = data;
        }
    }
};
</script>

<style lang="scss" scoped>
    .dialog {

        .form {

            .input-number {
                width: 100%;

                & /deep/ input {
                    text-align: left;
                }
            }
        }
    }
</style>
